import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginSectionComponent } from './login-section.component';
import { ButtonModule } from '@lib/components';
import { IfScreenSizeModule } from '@common/directives/if-screen-size/if-screen-size.module';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [LoginSectionComponent],
  imports: [CommonModule, ButtonModule, IfScreenSizeModule, StaticMsgModule],
  exports: [LoginSectionComponent],
})
export class LoginSectionModule {}
